import React from "react";
import { Button } from "antd";
import PropTypes from "prop-types";

const SecondaryButton = ({ children, ...props }) => {
  let newProps = JSON.parse(JSON.stringify(props));
  const className = `bg-white text-custom_darkgray border-1 border-custom_gray hover:text-custom_primary hover:border-custom_primary ${
    newProps.className ? newProps.className : ""
  }`;
  return (
    <Button {...props} className={className}>
      {children}
    </Button>
  );
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
};
export default SecondaryButton;
